import * as React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

import { Button } from '../ui/button';
import { comparerMois, decaler, libelleMois, moisCourant } from './reportHelpers';

/**
 * Sélecteur de période « ‹ mai 2026 › ». Les mois à venir ne sont pas
 * proposés: il n'y a rien à rapporter avant qu'ils commencent.
 */
const MonthSelector = ({ periode, onChange, maintenant }) => {
  const courant = moisCourant(maintenant);
  const suivantPossible = comparerMois(periode, courant) < 0;
  const estCourant = comparerMois(periode, courant) === 0;

  return (
    <div className="flex shrink-0 items-center gap-1.5" role="group" aria-label="Mois affiché">
      <Button
        type="button"
        variant="outline"
        size="icon"
        className="h-8 w-8"
        aria-label="Mois précédent"
        onClick={() => onChange(decaler(periode, -1))}
      >
        <ChevronLeft aria-hidden="true" />
      </Button>
      <p
        className="min-w-[7.5rem] text-center text-sm font-semibold capitalize text-foreground"
        aria-live="polite"
      >
        {libelleMois(periode)}
      </p>
      <Button
        type="button"
        variant="outline"
        size="icon"
        className="h-8 w-8"
        aria-label="Mois suivant"
        disabled={!suivantPossible}
        onClick={() => onChange(decaler(periode, 1))}
      >
        <ChevronRight aria-hidden="true" />
      </Button>
      {!estCourant && (
        <Button type="button" variant="ghost" size="sm" className="h-8 px-2 text-xs" onClick={() => onChange(courant)}>
          Mois en cours
        </Button>
      )}
    </div>
  );
};

export default MonthSelector;
